/**
 * Preview as Client, for the data layer.
 *
 * There is one preview mechanism and one place it is decided: PortalContext
 * derives it from the client link's ?preview=1 and a verified staff session,
 * then records it here so the shared-review helpers can honour it too.
 *
 * All it means is: read, never write. In particular join_project must not be
 * called, because joining records the viewer as a member of the project.
 */
let staffPreview = false

export function setStaffPreview(value: boolean): void {
  staffPreview = value
}

export function isStaffPreview(): boolean {
  return staffPreview
}
